import { useState } from "react";

export default function FullBleedImage({
  src,
  alt = "",
  className = "",
  children,
  overlay = true,
  height = "h-[92vh]",
  position = "center",
}) {
  const [loaded, setLoaded] = useState(false);

  return (
    <div className={`relative w-full overflow-hidden ${height} ${className}`}>
      <div
        aria-hidden
        className="absolute inset-0"
        style={{ background: "var(--bg-1)" }}
      />
      <img
        src={src}
        alt={alt}
        onLoad={() => setLoaded(true)}
        className={`absolute inset-0 h-full w-full object-cover transition-opacity duration-700 ${
          loaded ? "opacity-100" : "opacity-0"
        }`}
        style={{ objectPosition: position }}
        loading="eager"
      />
      {overlay && (
        <>
          <div
            aria-hidden
            className="absolute inset-0"
            style={{
              background:
                "linear-gradient(180deg, rgba(11,10,8,0.55) 0%, rgba(11,10,8,0.25) 35%, rgba(11,10,8,0.55) 100%)",
            }}
          />
          <div
            aria-hidden
            className="absolute inset-0"
            style={{
              background:
                "linear-gradient(90deg, rgba(11,10,8,0.65) 0%, rgba(11,10,8,0.2) 55%, rgba(11,10,8,0) 100%)",
            }}
          />
          <div className="absolute inset-0 vignette" aria-hidden />
          <div className="absolute inset-0 dusk-overlay" aria-hidden />
          <div className="noise-overlay" aria-hidden />
        </>
      )}
      {children && <div className="relative h-full">{children}</div>}
    </div>
  );
}
